import { Component, inject, input, OnInit, signal } from '@angular/core';
import { Router, RouterLink } from '@angular/router';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';

import { AuthService } from '../../services/auth.service';
import { STRINGS } from '@app/services/constants';
import { User } from '@app/models';
// TODO i18n Remove (unused)
const signoutError = $localize`:event:Unable to sign out`;

@Component({
  selector: 'app-header',
  imports: [
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatToolbarModule,
    RouterLink,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit {
  STR = STRINGS;

  account!: User;
  bare = input(false, { transform: (v) => v === 'true' });
  exit = signal(true);
  logo = input('');

  private authService = inject(AuthService);
  private router = inject(Router);

  ngOnInit() {
    this.account = this.authService.getUser();
    this.exit.set(!!this.account.id);
  }

  signOut() {
    this.authService.signOut().subscribe({
      complete: () => {
        this.exit.set(false);
      },
      error: () => {
        this.exit.set(false);
        void this.router.navigate(['/signin']);
      },
    });
  }
}
